import { render, staticRenderFns } from "./CruiseDetailCruiseInfo.vue?vue&type=template&id=66fd2fbf&scoped=true"
import script from "./CruiseDetailCruiseInfo.vue?vue&type=script&lang=js"
export * from "./CruiseDetailCruiseInfo.vue?vue&type=script&lang=js"
import style0 from "./CruiseDetailCruiseInfo.vue?vue&type=style&index=0&id=66fd2fbf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fd2fbf",
  null
  
)

export default component.exports